import { Directive, ElementRef, HostListener, Input, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[validateBtnCreateCargo]',
})
export class ValidateBtnCreateCargoDirective {

    @Input() step: { url: string, id: number, parentId: number };

    constructor(
        private el: ElementRef
    ) {
    }

    // tslint:disable-next-line: use-lifecycle-interface
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.step.currentValue) {
            
        }
    }

}
